import { z } from "zod/v4";

const ARRAY_SEPARATOR = ",";
const ENCODED_SEPARATOR = "%2C";

/**
 * Zod preprocessor for boolean search params written by nuqs in the legacy "true"/"false"
 * string format. `z.coerce.boolean` would treat the string `"false"` as truthy, so this
 * lowercases + compares explicitly instead.
 */
export const nuqsBoolean = (defaultValue: boolean) =>
  z
    .preprocess((value) => {
      const text = z.string().safeParse(value);
      return text.success ? text.data.toLowerCase() === "true" : value;
    }, z.boolean())
    .default(defaultValue);

/** String-array search param; also accepts the legacy comma-joined URL format for old deep links. */
export const nuqsCommaArray = z
  .union([
    z
      .array(z.string().optional().catch(undefined))
      .transform((items) => items.filter((item) => item !== undefined)),
    z
      .string()
      .transform((value) =>
        value === ""
          ? []
          : value
              .split(ARRAY_SEPARATOR)
              .map((item) => item.replaceAll(ENCODED_SEPARATOR, ARRAY_SEPARATOR)),
      ),
  ])
  .catch([])
  .default([]);
